import { z } from 'zod';
const ClockingRecordsSearchSchema = z.object({
  /** 一覧は月単位。YYYY-MM。未指定時は API が DB から既定月を決定 */
  yearMonth: z.string().optional(),
  /** 旧 URL 互換（YYYY-MM-DD）。先頭 7 文字を yearMonth として扱う */
  date: z.string().optional(),
  freeText: z.string().optional(),
  /** "all" または勤務地名（CLOCKING_RECORDS_DEMO_WORKPLACES） */
  workplace: z.string().default('all'),
  approval: z.enum(['all', 'pending', 'approved', 'rejected']).default('all'),
  pageIndex: z.coerce.number().default(0),
  pageSize: z.coerce.number().default(100)
});
export type ClockingRecordsSearchParams = z.infer<typeof ClockingRecordsSearchSchema>;

/** 出勤簿の閲覧スコープ（自分 / 自分のチーム / 所属店舗）。 */
const CLOCKING_SCOPE_VALUES = ['self', 'team', 'store'] as const;
export type ClockingScope = (typeof CLOCKING_SCOPE_VALUES)[number];

/** 従業員別打刻詳細: 年月（未指定時は beforeLoad で最新月へリダイレクト）+ 閲覧スコープ */
export const EmployeeClockingDetailSearchSchema = z.object({
  year: z.coerce.number().int().min(2000).max(2100).optional(),
  month: z.coerce.number().int().min(1).max(12).optional(),
  scope: z.enum(CLOCKING_SCOPE_VALUES).catch('self')
});